// extracted by mini-css-extract-plugin
module.exports = {"container":"paypal-payment-button_container__nrVO9","frame":"paypal-payment-button_frame__2Kaea"};